module.exports = __webpack_public_path__ + "img/SES_235415200.1e28ac19.jpg";